import store from '../store'
const authorityObj = {
    isShow(id) {
        let flag = false;
        store.state.tab.AuthorityButtonArr.some(x => {
            if (x.menuCode == id) {
                flag = true;
                return true;
            }
        })
        return flag;
    },
    getName(id){
        let name = '';
        store.state.tab.AuthorityButtonArr.some(x => {
            if (x.menuCode == id) {
                name = x.menuName;
                return true;
            }
        })
        return name;
    },
    isShowPage(id){
        let flag = false;
        store.state.tab.AuthorityPageArr.some(x => {
            if (x.menuCode == id) {
                flag = true;
                return true;
            }
        })
        return flag;
    },
    setAuthorityData(resArr){
        let asideData = [{
            path: "/home",
            name: "home",
            label: "首页",
            // icon: "s-home",
            icon: "icon-shouye",
        }];//
        // let resArr = this.authorityData;
        resArr.some((x)=>{
            if(x.node.menuCode == '#5'){  //#5
                let xobj = {};
                xobj.label = "用户管理";
                // xobj.icon = "user";
                xobj.icon = "icon-yonghuguanli";
                xobj.name = "user";
                // if(x.childNodes && x.childNodes.length>0){
                    xobj.children = [];
                    x.childNodes.some((y)=>{
                        if(y.node.menuCode == '#5#6'){
                            // xobj.path = "/user";
                            let inobj = {
                                path: "/userList",
                                name: "userList",
                                label: '用户列表',
                                icon: "s-comment",
                            }
                            xobj.children.push(inobj);
                            asideData.push(xobj);
                        }
                    })
                // }
                // if(xobj.name){
                //     asideData.push(xobj);
                // }
            }


            if(x.node.menuCode == '#12'){  //#5
                let xobj = {};
                xobj.label = "会议管理";
                xobj.label = x.node.menuName;
                // xobj.icon = "suitcase";
                xobj.icon = "icon-huiyiguanli";
                xobj.name = "meeting";
                if(x.childNodes && x.childNodes.length>0){
                    xobj.children = [];
                    x.childNodes.some((y)=>{
                        if(y.node.menuCode == '#12#13'){
                            let inobj = {
                                path: "/meetManager",
                                name: "meetManager",
                                label: y.node.menuName,
                                // icon: "s-comment",
                                icon: "icon-huiyiguanli",
                            }
                            xobj.children.push(inobj);
                        }
                    })
                }
                asideData.push(xobj);
            }

            if(x.node.menuCode == '#19'){  //#5
                let xobj = {};
                xobj.label = "论文管理";
                xobj.name = "paper";
                xobj.label = x.node.menuName;
                // xobj.icon = "reading";
                xobj.icon = "icon-lunwenguanli";
                if(x.childNodes && x.childNodes.length>0){
                    x.childNodes.some((y)=>{
                        if(y.node.menuCode == '#19#20'){
                            xobj.children = [];
                            let inobj = {
                                path: "/Papers",
                                name: "Papers",
                                label: y.node.menuName,
                                icon: "setting",
                            }
                            xobj.children.push(inobj);
                        }
                        if(y.node.menuCode == '#19#67'){
                            if(!xobj.children){
                                xobj.children = [];
                            }
                            let inobj = {
                                path: "/paperReviewManager",
                                name: "paperReviewManager",
                                label: y.node.menuName,
                                icon: "setting",
                            }
                            xobj.children.push(inobj);
                        }
                    })
                }
                asideData.push(xobj);
            }

            if(x.node.menuCode == '#1'){  //#5
                let xobj = {};
                xobj.label = "个人中心";
                xobj.label = x.node.menuName;
                // xobj.icon = "s-custom";
                xobj.icon = "icon-gerenzhongxin";
                xobj.name = "personCenter";
                if(x.childNodes && x.childNodes.length>0){
                    xobj.children = [];
                    x.childNodes.some((y)=>{
                        if(y.node.menuCode == '#1#3'){
                            let inobj = {
                                path: "/personCenterManager",
                                name: "personCenterManager",
                                label: y.node.menuName,
                                icon: "s-comment",
                            }
                            xobj.children.push(inobj);
                        }
                        if(y.node.menuCode == '#1#2'){
                            let inobj = {
                                path: "/personCenterInfo",
                                name: "personCenterInfo",
                                label: y.node.menuName,
                                icon: "s-comment",
                            }
                            xobj.children.push(inobj);
                        }
                        if(y.node.menuCode == '#1#4'){
                            let inobj = {
                                path: "/personCenterLogs",
                                name: "personCenterLogs",
                                label: y.node.menuName,
                                icon: "s-comment",
                            }
                            xobj.children.push(inobj);
                        }
                    })
                }
                asideData.push(xobj);
            }
        })

        store.commit('setAsideData',asideData);
    },
    setAuthorityButtonData(resArr){
        let AuthorityButtonArr = [];

        // let resArr = this.authorityData;
        resArr.some((x)=>{
            if(x.childNodes && x.childNodes.length>0){
                x.childNodes.some((y)=>{
                    if(y.childNodes && y.childNodes.length>0){
                        y.childNodes.some((z)=>{
                            let obj = {};
                            obj.menuCode = z.node.menuCode;
                            obj.menuName = z.node.menuName;
                            AuthorityButtonArr.push(obj);
                        })
                    }
                })
            }
        })
        store.commit('setAuthorityButtonArr',AuthorityButtonArr);
    },
    setAuthorityPageData(resArr){
        let AuthorityPageArr = [];

        // let resArr = this.authorityData;
        resArr.some((x)=>{
            if(x.childNodes && x.childNodes.length>0){
                x.childNodes.some((y)=>{
                    let obj = {};
                    obj.menuCode = y.node.menuCode;
                    obj.menuName = y.node.menuName;
                    AuthorityPageArr.push(obj);
                })
            }
        })
        store.commit('setAuthorityPageArr',AuthorityPageArr);
    },
    getRoleNameByCode(code){
        let name = '';
        this.$store.state.dict.RoleList.some(x=>{
            if(x.roleCode == code){
                name = x.roleName;
                return true;
            }
        })
        return name;
    },
}

export default authorityObj
